import React, { FC, useEffect, useRef } from 'react'
import { NarrationModel } from '@store/slices/narration.slice'
import { useTheme } from '@config/theme.config'
import CodeMirror, {
  EditorView,
  ReactCodeMirrorRef,
} from '@uiw/react-codemirror'
import { highlightSelectionMatches } from '@codemirror/search'
import { xml } from '@codemirror/lang-xml'
import { vscodeDark, vscodeLight } from '@uiw/codemirror-theme-vscode'
import { indentRange } from '@codemirror/language'
import { useNarrationFormContext } from '@components/narration/narration.component'

const SsmlEditorComponent: FC = () => {
  const { theme } = useTheme()
  const editorRef = useRef<ReactCodeMirrorRef>(null)
  const { setNarrationInEditing, narrationInEditing } =
    useNarrationFormContext()

  useEffect(() => {
    if (editorRef.current && editorRef.current.view) {
      const editorView = editorRef.current.view
      const state = editorView.state

      const from = 0
      const to = state.doc.length

      // Get the indent effects for the whole document
      const indentEffects = indentRange(state, from, to)

      // Create and dispatch a transaction to apply the indent effects
      const transaction = state.update({
        changes: indentEffects,
      })

      editorView.dispatch(transaction)
    }
  }, [editorRef.current])

  const handleEditorChange = (value: string) => {
    if (narrationInEditing) {
      const updatedNarration = {
        ...narrationInEditing,
      }
      updatedNarration['ssml'] = value

      return setNarrationInEditing(updatedNarration as NarrationModel)
    }
  }

  return (
    <CodeMirror
      className={'overflow-y-scroll'}
      style={{
        maxHeight: '60vh',
        scrollbarWidth: 'auto',
      }}
      ref={editorRef}
      value={narrationInEditing?.ssml}
      onChange={handleEditorChange}
      extensions={[
        xml(),
        EditorView.lineWrapping,
        highlightSelectionMatches({ maxMatches: 0 }),
      ]}
      theme={theme === 'dark' ? vscodeDark : vscodeLight}
    />
  )
}

export default SsmlEditorComponent
